/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CallPassCharts from './CallPassCharts'; // Import the new chart component
import formatDateTimeToPST from '../../PSTDateConvert';
import Pagination from 'react-js-pagination';
import * as XLSX from "xlsx";
import PopupImage from '../../CiaDashboard/PopupImage';
import { saveAs } from 'file-saver';
 
const CallPassDisplayIdentities = () => {
    const location = useLocation();
    // 'initialFilters' holds filter values passed from another page
    const { initialFilters } = location.state || {};

    console.log('initialFilters', initialFilters)

    const [name, setName] = useState('');
    const [timeZone, seTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [cid, setCid] = useState('');
    const [expire, setExpire] = useState('');  
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [logoPopupOpen, setLogoPopupOpen] = useState(false);
    const [logoPopupUrl, setLogoPopupUrl] = useState(null);
    const [callPassDisplayIdentitiesAccess, setCallPassDisplayIdentitiesAccess] = useState(false);
    const [userCallPassDisplayIdentitiesAccess, setUserCallPassDisplayIdentitiesAccess] = useState(false);
    const [canEditIdentities, setCanEditIdentities] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);
    const [company, setCompany] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    // Date and Time range filters
    const getYesterday = () => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return yesterday;
    };
    // Initialize filter states:
    // 1. From 'initialFilters' if present (e.g., coming from Details page).
    // 2. Else, use default values.
    // const [startDate, setStartDate] = useState(
    //     initialFilters?.startDate ? new Date(initialFilters.startDate) : getYesterday()
    // );
    // const [endDate, setEndDate] = useState(
    //     initialFilters?.endDate ? new Date(initialFilters.endDate) : new Date()
    // );
    // const [startTime, setStartTime] = useState(initialFilters?.startTime || "00:00");
    // const [endTime, setEndTime] = useState(initialFilters?.endTime || "23:59");
    const [selectedCompany, setSelectedCompany] = useState(initialFilters?.selectedCompany || "");

    // Other filters
    const [selectedEntity, setSelectedEntity] = useState(initialFilters?.selectedEntity || "");
    const [selectedDisplayIdentity, setSelectedDisplayIdentity] = useState(initialFilters?.selectedDisplayIdentity || "");
    const [selectedOrigationNumber, setSelectedOrigationNumber] = useState(initialFilters?.selectedOrigationNumber || "");
    

    // Options for filters (to be fetched from API)
    const [entityOptions, setEntityOptions] = useState([]);
    const [displayIdentityOptions, setDisplayIdentityOptions] = useState([]);
    const [origationNumberOptions, setOrigationNumberOptions] = useState([]);

    // Summary Data
    const [summaryData, setSummaryData] = useState([]);

    // State for chart drilldown
    const [selectedDisplayIdentityForDrilldown, setSelectedDisplayIdentityForDrilldown] = useState(null);
    const isInitialPageLoadForAutoApply = React.useRef(true); // Ref to track initial auto-apply

    const handleDisplayIdentityClick = (payload) => {
        // If we click the same bar again, toggle off the drill-down.
        if (selectedDisplayIdentityForDrilldown && payload && selectedDisplayIdentityForDrilldown.label === payload.label) {
            setSelectedDisplayIdentityForDrilldown(null);
        } else {
            // Otherwise, set the new selection for drill-down.
            setSelectedDisplayIdentityForDrilldown(payload);
        }
    };

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        getUserCompany();
    }, []);

    useEffect(() => {
        if(cid){
            checkPageAccess();
        }
    }, [cid]);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    useEffect(() => {
        if(role >= 3 && cid){
            setSelectedCompany(cid);
        }
    }, [cid, role]);

    // Effect to auto-apply filters on initial load if selectedCompany is present from initialFilters
    useEffect(() => {
        if (
            
            isInitialPageLoadForAutoApply.current &&
            (role >= 3 || (role <= 2 && initialFilters?.selectedCompany)) && // Check if a company was passed initially
            selectedCompany && // Ensure state is also updated (should match initialFilters)
            token &&
            cid &&
            callPassDisplayIdentitiesAccess &&
            userCallPassDisplayIdentitiesAccess
        ) {
            console.log("Initial load with selectedCompany, applying filters automatically for Summary page.");
            handleApplyFilters();
            isInitialPageLoadForAutoApply.current = false; // Prevent re-triggering
        }
    }, [
        initialFilters?.selectedCompany,
        selectedCompany,
        token,
        cid,
        role,
        callPassDisplayIdentitiesAccess,
        userCallPassDisplayIdentitiesAccess,
    ]);

    useEffect(() => {
        fetchDisplayIdentitiesData(page, selectedCompany);
    },[page, selectedCompany])


    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        } catch (error) {
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    
    const checkPageAccess = async () => {
        try {
            incrementLoading();
            // Fetch all required data            
            const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            const callPassDisplayIdentitiesSwitch = customerDigitMappingResponse.data.call_pass_display_identities_switch;
            const userCallPassDisplayIdentitiesSwitch = userAccessResponse.data.user_call_pass_display_identities_switch;
            decrementLoading();
            setAccess(userAccessResponse.data.results);
            // Conditional check for access
            if (
                callPassDisplayIdentitiesSwitch >= 1 &&
                userCallPassDisplayIdentitiesSwitch >= 1
            ) {
                setUserCallPassDisplayIdentitiesAccess(true);
                setCallPassDisplayIdentitiesAccess(true);
                setCanEditIdentities(parseInt(callPassDisplayIdentitiesSwitch) >= 2 && parseInt(userCallPassDisplayIdentitiesSwitch) >= 2);
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Error checking page access:", error);
            navigate('/dashboard'); // Redirect in case of any error
        }
    };

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const company = response.data.filter(item => item.id !== 1);
        // company.shift();
        // console.log(response.data);
        setCompany(company);
    }

    const formatDateToYYYYMMDD = (date) => {
        if (!date) return ''; // Handle null or undefined dates
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const fetchDisplayIdentitiesData = async (page, company) => {
        incrementLoading();
        try {
            // TODO: Replace with actual API endpoint and payload
            const response = await axiosJWT.get(`${baseUrl}/call-pass-display-identities`, {
                params: { 
                    page: page,
                    limit: 20, 
                    company: company,
                },
                headers: { Authorization: `Bearer ${token}` }
            });
            setSummaryData(response.data.summary || []);
            setTotalItem(response.data.totalItem);
            setSelectedDisplayIdentityForDrilldown(null);
            console.log("Fetched summary data based on all filters.");
        } catch (error) {
            console.error("Error fetching summary data:", error);
            // Handle error
        } finally {
            decrementLoading();
        }
    };

    const handleApplyFilters = () => {
        // Data fetching is triggered by useEffect dependencies,
        // but you might want an explicit button to signify user action.        
        fetchDisplayIdentitiesData(1, selectedCompany); // Or let useEffect handle it
       
    };

    const handleClearFilters = () => {
        setSelectedCompany("");
        setSelectedEntity("");
        setSelectedDisplayIdentity("");
        setSelectedOrigationNumber("");
        fetchDisplayIdentitiesData(1, "");
    };

    const isDefaultDate = (date, defaultDateFunc) => {
        const defaultDate = defaultDateFunc();
        return date.getFullYear() === defaultDate.getFullYear() &&
               date.getMonth() === defaultDate.getMonth() &&
               date.getDate() === defaultDate.getDate();
    };
 
    const showClearButton = selectedCompany !== "" ||
                            selectedEntity !== "" ||
                            selectedDisplayIdentity !== "" ||
                            selectedOrigationNumber !== "";    
    
    const gotoSwitchScreen = (e, entity, displayIdentity) => {
        e.preventDefault();
        
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                selectedCompany,
                selectedEntity: entity,
                selectedDisplayIdentity: displayIdentity,
                selectedOrigationNumber,
            }
        };
        
        navigate("/call-pass-display-identity-details", { state: navigationState });
        
    }

    const exportCallPassEnabledNumbersDisplayIdentityData = async () => {
        try {
            setPopupOpen(true)
            const response = await axiosJWT.get(`${baseUrl}/export-call-pass-enabled-numbers-display-identity-data`, {
                params: { 
                    cid: selectedCompany,
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const responseData = response.data;

            const formattedData = responseData.data.map(item => ({
                "Telephone Number": item.tn,
                "Customer Name": company.find(c => c.id == selectedCompany)?.cname || '',
                "Call Pass Enable Date": item.call_pass_enable_date || '',
                "Display Name": item.display_name,
                "Logo": item.logo,
                "Call Reason": item.call_reason,
                "Entity Name": item.entity_name
            }));

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(formattedData);

            XLSX.utils.book_append_sheet(workbook, worksheet, "CallPassEnabled");

            // Convert to Excel buffer
            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            // Convert to Blob
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            // Save file
            saveAs(blob, "call-pass-enabled-numbers.xlsx")

        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            setPopupOpen(false)
        }
    }
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    const handleNavigateTnHistoryLogs = (e, entity, displayIdentity) => {
        e.preventDefault();
        
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                selectedCompany,
            }
        };
        
        navigate("/call-pass-display-identities/tn/history", { state: navigationState });
        
    }

    const handleNavigateChangeTnDisplayIdentity = (e) => {
        e.preventDefault();
        
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                selectedCompany,
            }
        };
        
        navigate("/call-pass-display-identity-tn-manage", { state: navigationState });
    }

    const handleNavigateImportCallPassDiridTn = (e) => {
        e.preventDefault();
        
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                selectedCompany,
            }
        };
        
        navigate("/import-call-pass-dirid-tn", { state: navigationState });
    }
    
 
    return (<>
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-4">
                            <div className="left-title">
                                <h1>Call Pass Display Identities</h1>
                            </div>
                        </div>
                        <div className="col-8 inventory-btn">
                            <div className="addnew-button flex gap-2">
                                {selectedCompany && <button className="btn-primary" onClick={exportCallPassEnabledNumbersDisplayIdentityData}>Export</button>}
                                {selectedCompany && <button className='btn-primary' onClick={handleNavigateTnHistoryLogs}>Tn History</button>}
                                {canEditIdentities && <button className="btn-primary" onClick={handleNavigateChangeTnDisplayIdentity}>View/Edit TN</button>}
                                {canEditIdentities && <button className="btn-primary" onClick={handleNavigateImportCallPassDiridTn}>Import</button>}
                                <Link to="/dashboard"><span>&larr;</span>Dashboard</Link>
                            </div>
                        </div>                        
                    </div>

                    {/* Filter Section */}
                    {role <=2 && <div className="common-white-shadow-background setting-section">
                        <div className="row filter-section align-items-end"> {/* All filters and buttons in this single row, align items to bottom */}
                            <div className="col-md-2">
                                <label>Company:</label>
                                <select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)} className="form-control">
                                <option value="" >Company</option>
                                    {company.map(option => (
                                        <option key={option.id} value={option.id}>{option.cname}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>}

                    {summaryData.length > 0 && <div className="common-white-shadow-background setting-section">
                        <div className="row">
                        <div className=" setting-section haft-whitebox">
                            <div className="search-result-section">
                                <h3></h3>
                                {/* <div className="export-btn newrow"><a className="newrow" href="#">Export</a></div> */}
                            </div>
                                <table className="tablebox search-result-table">
                                    <thead>
                                        <tr>                                            
                                            <th>Display Name</th>
                                            <th>Entity Name</th>
                                            <th>Logo Status</th>
                                            <th>Logo</th>
                                            <th>Call Reason</th>
                                            <th>Created Date ({timeZone})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {summaryData.map((item, index) => (
                                            <tr key={index}>
                                                <td><a href='#' onClick={(e) => gotoSwitchScreen(e, item.eid, item.dirid )}>{item?.display_name}</a></td>
                                                <td>{item?.entity_name}</td>
                                                <td>{item?.logo}</td>
                                                <td>
                                                    {item.logo_url && (
                                                        <img
                                                        src={item.logo_url}
                                                        alt="logo"
                                                        style={{ width: 40, height: 40, cursor: 'pointer' }}
                                                        onClick={() => { setLogoPopupUrl(item.logo_url); setLogoPopupOpen(true); }}
                                                        />
                                                    )}
                                                </td>
                                                <td>{item?.call_reason}</td>
                                                <td>{formatDateTimeToPST(item?.created_date, timeZone, role)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                
                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
        {logoPopupOpen && <PopupImage data={logoPopupUrl} onClose={() => setLogoPopupOpen(false)} />}
    </>
    )
}

export default CallPassDisplayIdentities;